export const menuLists = [
    {
        name: '首页',
        path: '/libHome',
        includePah: ['', '/libHome'],
    }, {
        name: '图书检索',
        path: '/bookSearch',
        includePah: ['/bookSearch','/bookDetail'],
    }, {
        name: '排行榜',
        path: '/rank',
        includePah: ['/rank', '/exhibition-detail'],
    },
    // {
    //     name: '活动专题',
    //     path: '/active',
    //     includePah: ['/active', '/cultural-relics/detail'],
    // }, {
    //     name: '教育专题',
    //     path: '/educate',
    //     includePah: ['/educate', '/information/detail'],
    // }, {
    //     name: '在线问答',
    //     path: '/onlineAnswer',
    //     includePah: ['/onlineAnswer', '/information/detail'],
    // },{
    //     name: '在线测评',
    //     path: '/onlineAnswer?type=1',
    //     includePah: ['/onlineAnswer?type=1', '/information/detail'],
    // },
]
